import styled from 'styled-components/macro';

export const NoContentMessage = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const NoContentContainer = styled.div`
  width: 100%;
  text-align: center;
`;
